'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import styled from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { useBinding } from '../../hooks/useBinding/useBinding.js';
import { hideVisually } from '../../mixins/hideVisually.js';
import '../Icons/AlignStartHorizontalIcon.js';
import '../Icons/ArchiveIcon.js';
import '../Icons/ArrowDownIcon.js';
import '../Icons/ArrowLeftBottomIcon.js';
import '../Icons/ArrowLeftIcon.js';
import '../Icons/ArrowLeftTopIcon.js';
import '../Icons/ArrowRightBottomIcon.js';
import '../Icons/ArrowRightIcon.js';
import '../Icons/ArrowRightTopIcon.js';
import '../Icons/BagIcon.js';
import '../Icons/BasketIcon.js';
import '../Icons/BellFilledIcon.js';
import '../Icons/BellNotificationIcon.js';
import '../Icons/BellOutlineIcon.js';
import '../Icons/BinocularsIcon.js';
import '../Icons/BlocksIcon.js';
import '../Icons/BoltIcon.js';
import '../Icons/BookIcon.js';
import '../Icons/BookmarkAddFilledIcon.js';
import '../Icons/BookmarkAddOutlineIcon.js';
import '../Icons/BookmarkIcon.js';
import '../Icons/BookOpenedIcon.js';
import '../Icons/BoxAltIcon.js';
import '../Icons/BusinessIcon.js';
import '../Icons/CalendarIcon.js';
import '../Icons/CancelIcon.js';
import '../Icons/CardsIcon.js';
import '../Icons/ChatAltIcon.js';
import '../Icons/ChatIcon.js';
import '../Icons/CheckboxIcon.js';
import '../Icons/CheckCirlcleFilledIcon.js';
import '../Icons/CheckSquareIcon.js';
import '../Icons/ChevronDoubleLeftIcon.js';
import '../Icons/ChevronDoubleRightIcon.js';
import '../Icons/ChevronDownIcon.js';
import '../Icons/ChevronLeftIcon.js';
import '../Icons/ChevronRightIcon.js';
import '../Icons/ChevronUpIcon.js';
import '../Icons/ClipboardEditIcon.js';
import '../Icons/ClipboardIcon.js';
import '../Icons/CloseIcon.js';
import '../Icons/CollapseIcon.js';
import '../Icons/ControlsIcon.js';
import '../Icons/ControlsVerticalAltIcon.js';
import '../Icons/CopyIcon.js';
import '../Icons/CutIcon.js';
import '../Icons/DangerIcon.js';
import '../Icons/DownloadCloudIcon.js';
import '../Icons/DownloadIcon.js';
import '../Icons/DownloadPdfIcon.js';
import '../Icons/DrawerOpenIcon.js';
import '../Icons/EllipsisIcon.js';
import '../Icons/EllypsisVerticalIcon.js';
import '../Icons/EnvelopeIcon.js';
import '../Icons/ErrorIcon.js';
import '../Icons/ExitIcon.js';
import '../Icons/ExpandIcon.js';
import '../Icons/ExternalLinkIcon.js';
import '../Icons/EyeCrossedIcon.js';
import '../Icons/EyeIcon.js';
import '../Icons/FacebookIcon.js';
import '../Icons/FavouriteIcon.js';
import '../Icons/FileBadgeIcon.js';
import '../Icons/FileIcon.js';
import '../Icons/FileSearchIcon.js';
import '../Icons/FileType2Icon.js';
import '../Icons/FilmIcon.js';
import '../Icons/FitscreenIcon.js';
import '../Icons/FocusIcon.js';
import '../Icons/FolderAddIcon.js';
import '../Icons/FolderClosedIcon.js';
import '../Icons/FolderIcon.js';
import '../Icons/FutureIcon.js';
import '../Icons/GalleryVerticalEndIcon.js';
import '../Icons/GridIcon.js';
import '../Icons/HelpIcon.js';
import '../Icons/HistoryIcon.js';
import '../Icons/HomeIcon.js';
import '../Icons/InformationIcon.js';
import '../Icons/InstagramIcon.js';
import '../Icons/LibraryIcon.js';
import '../Icons/LightbulbIcon.js';
import '../Icons/LinkedinIcon.js';
import '../Icons/ListIcon.js';
import '../Icons/ListSearchIcon.js';
import '../Icons/Loader2Icon.js';
import '../Icons/LockAltIcon.js';
import '../Icons/LockAltOpenIcon.js';
import '../Icons/LockIcon.js';
import '../Icons/LockOpenIcon.js';
import '../Icons/MagazineIcon.js';
import '../Icons/MailIcon.js';
import '../Icons/Maximize2Icon.js';
import '../Icons/MenuCollapsable2Icon.js';
import '../Icons/MenuCollapsableIcon.js';
import '../Icons/MenuDotsIcon.js';
import '../Icons/MenuIcon.js';
import '../Icons/MinusIcon.js';
import '../Icons/NewsIcon.js';
import '../Icons/NtfrIcon.js';
import '../Icons/OkCircleIcon.js';
import '../Icons/OkIcon.js';
import '../Icons/PencilIcon.js';
import '../Icons/PenSquareIcon.js';
import '../Icons/People2Icon.js';
import '../Icons/PeopleIcon.js';
import '../Icons/PersonIcon.js';
import '../Icons/PhoneCallIcon.js';
import '../Icons/PlayFilledIcon.js';
import '../Icons/PlayIcon.js';
import '../Icons/PlusCircleIcon.js';
import '../Icons/PlusIcon.js';
import '../Icons/PlusSquareIcon.js';
import '../Icons/PrintIcon.js';
import '../Icons/RadioIcon.js';
import '../Icons/RefreshCwIcon.js';
import '../Icons/RotateIcon.js';
import { SearchIcon } from '../Icons/SearchIcon.js';
import '../Icons/SettingsIcon.js';
import '../Icons/ShareIcon.js';
import '../Icons/ShieldIcon.js';
import '../Icons/SocialXIcon.js';
import '../Icons/StarFilledIcon.js';
import '../Icons/StarOutlineIcon.js';
import '../Icons/StickyNoteIcon.js';
import '../Icons/SwapHorizontalIcon.js';
import '../Icons/TablePropertiesIcon.js';
import '../Icons/TasklistIcon.js';
import '../Icons/ThumbDownIcon.js';
import '../Icons/ThumbsDownIcon.js';
import '../Icons/ThumbsUpIcon.js';
import '../Icons/ThumbUpIcon.js';
import '../Icons/TimeIcon.js';
import '../Icons/TimerIcon.js';
import '../Icons/Trash2Icon.js';
import '../Icons/TrashIcon.js';
import '../Icons/UpgradeIcon.js';
import '../Icons/UploadIcon.js';
import '../Icons/UserIcon.js';
import '../Icons/VideoIcon.js';
import '../Icons/WorldIcon.js';
import '../Icons/XposiIcon.js';
import '../Icons/YoutubeIcon.js';
import { Input } from '../Input/Input.js';

const HiddenSubmitButton = styled.button.withConfig({
  componentId: "sc-1chg4fw-0"
})(["outline:none;z-index:-1;", ";"], hideVisually);
const StyledForm = styled.form.withConfig({
  componentId: "sc-1chg4fw-1"
})(["width:100%;"]);
const SearchFormContainer = /*#__PURE__*/withTitan(({
  onSubmit,
  children,
  testId = 'searchFormContainer',
  labelSubmit = 'Submit'
}) => {
  const onFormSubmit = e => {
    e.preventDefault();
    onSubmit();
  };
  return jsxs(StyledForm, {
    "data-test-id": testId,
    onSubmit: onFormSubmit,
    children: [children, jsx(HiddenSubmitButton, {
      "aria-label": labelSubmit,
      "data-test-id": `${testId}Button`,
      tabIndex: -1,
      title: labelSubmit,
      type: "submit"
    })]
  });
}, {
  name: 'SearchFormContainer'
});
const SearchForm = /*#__PURE__*/withTitan(_a => {
  var {
      defaultValue = '',
      value,
      onInputChange,
      onSubmit,
      testId = 'searchForm',
      label = 'Zoeken'
    } = _a,
    rest = __rest(_a, ["defaultValue", "value", "onInputChange", "onSubmit", "testId", "label"]);
  const [inputValue, setInputValue] = useBinding(defaultValue, value, onInputChange, '');
  const onFormSubmit = () => {
    onSubmit(inputValue);
  };
  return jsx(SearchFormContainer, Object.assign({
    testId: testId,
    onSubmit: onFormSubmit
  }, rest, {
    children: jsx(Input, Object.assign({
      isClearable: true,
      isLabelHidden: true,
      label: label,
      maxLength: 255,
      name: "search",
      prefixAdornment: jsx(SearchIcon, {}),
      type: "text",
      value: inputValue,
      onInputChange: setInputValue
    }, rest))
  }));
}, {
  name: 'SearchForm',
  memo: true
});

export { SearchForm, SearchFormContainer };
//# sourceMappingURL=SearchForm.js.map
